import { Injectable } from '@angular/core';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  userAccount : any = null;

  constructor(private apiService: ApiService) { }

  getUser()
  {
    let user = localStorage.getItem('user');
    if(user !== null) {
      this.userAccount = JSON.parse(user);
      return this.userAccount;
    }
    else {
      return null;
    }
  }

  public async verifyAccount(hash: string) {
    let route = 'users/verify';
    let body = {
      hash,
    }
    return await this.apiService.post(route, null, body);
  }

  public async resetPassword(password: string, hash: string) {
    let route = 'users/resetPassword';
    let body = {
      password,
      hash,
    }
    return await this.apiService.post(route, null, body);
  }

  public async forgotPassword(email: string) {
    let route = 'users/forgetPassword';
    let body = {
      email
    }
    return await this.apiService.post(route, null, body);
  }

  public async login(email: string, password: string) {
    let route = 'users/login';
    let body = {
      email, password
    }
    return await this.apiService.post(route, null, body);
  }

  public async getUsers() {
    let route = 'users';
    let userObj = this.getUser();
    return this.apiService.get(route, userObj);
  }

  public async addUser(newUser:any) {
    let route = 'users';
    let userObj = this.getUser();
    let body = { ...newUser };
    return await this.apiService.post(route, userObj, body);
  }

  public async updateUser(newUser:any) {
    let route = 'users';
    let userObj = this.getUser();
    let body = { ...newUser };
    return await this.apiService.put(route, userObj, body);
  }

  public async getUserNames() {
    let route = 'users/names';
    let userObj = this.getUser();
    return this.apiService.get(route, userObj);
  }

}
